import { Grid, List, Stack, Switch, FormControlLabel } from '@mui/material';
import { MainContentPanel } from '../components/MainContentPanel';
import { gql } from '../__generated__';
import { useQuery } from '@apollo/client/react';
import { useState } from 'react';
import { WidgetTitle } from '../dashboard/WidgetTitle';
import LoadingSpinner from '../components/LoadingSpinner';
import StarIcon from '@mui/icons-material/Star';
import SchoolIcon from '@mui/icons-material/School';
import { Link } from 'react-router-dom';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { nbNO } from '@mui/x-data-grid/locales';

const QUERY = gql(`
  query NewSubscriptionsReport($monthOffset: Int!, $onlyNew: Boolean!, $includeStudents: Boolean!) {
    lisenses: getNewSubscriptions(monthOffset: $monthOffset, onlyNew: $onlyNew, includeStudents: $includeStudents) {
      licenseId
      name
      isNew
      isStudent
      subscriptionsAdded
    }
  }
`);

interface License {
  licenseId: number;
  name: string;
  isNew: boolean;
  isStudent: boolean;
  subscriptionsAdded: string;
}

export function NewSubscriptions(props) {
  var take = 100;

  const [monthOffset, setMonthOffset] = useState(Number(props.offset));

  const [onlyNew, setonlyNew] = useState(false);
  const [includeStudents, setincludeStudents] = useState(false);

  const { loading, data } = useQuery<any, any>(QUERY, {
    variables: { monthOffset: monthOffset, take: take, onlyNew: onlyNew, includeStudents: includeStudents },
    fetchPolicy: 'network-only',
  });

  return (
    <>
      <Grid container>
        <Grid size={5}>
          <WidgetTitle
            title="Nye kunder og brukerlisenser i"
            offset={monthOffset}
            stateSetter={(step) => {
              setMonthOffset(monthOffset + step);
            }}
          />

          <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
            <Stack direction="row" sx={{alignItems: 'center'}}>
              <FormControlLabel
                control={<Switch onChange={() => setonlyNew(!onlyNew)} checked={onlyNew} />}
                label={
                  <span>
                    Kun nye
                    <StarIcon
                      style={{
                        marginLeft: 5,
                        verticalAlign: 'middle',
                        color: 'gold',
                      }}
                    />
                  </span>
                }
              />
              <FormControlLabel
                control={<Switch onChange={() => setincludeStudents(!includeStudents)} checked={includeStudents} />}
                label={
                  <span>
                    Inkluder studenter
                    <SchoolIcon
                      style={{
                        marginLeft: 5,
                        verticalAlign: 'middle',
                        color: 'grey',
                      }}
                    />
                  </span>
                }
              />
            </Stack>
          </Stack>

          {loading && <LoadingSpinner />}
          {!loading && !data && <div>Mangler data</div>}
          {data && renderDetails(data.lisenses)}
        </Grid>
      </Grid>
    </>
  );

  function renderDetails(licenses) {
    const rows = licenses.map((license: License) => ({
      id: license.licenseId,
      licenseId: license.licenseId,
      name: license.name,
      isNew: license.isNew,
      isStudent: license.isStudent,
      subscriptionsAdded: license.subscriptionsAdded,
    }));

    const columns: GridColDef<(typeof rows)[number]>[] = [
      {
        field: 'name',
        headerName: 'Navn',
        minWidth: 160,
        flex: 1,
        align: 'left',
        headerAlign: 'left',
        renderCell: (params) => (
          <>
            <Link to={`/license/${params.row.licenseId}`}>{params.row.name}</Link>
            {params.row.isNew && (
              <span>
                <StarIcon
                  style={{
                    marginLeft: 5,
                    verticalAlign: 'middle',
                    color: 'gold',
                  }}
                />
              </span>
            )}
            {params.row.isStudent && (
              <span>
                <SchoolIcon
                  style={{
                    marginLeft: 5,
                    verticalAlign: 'middle',
                    color: 'grey',
                  }}
                />
              </span>
            )}
          </>
        ),
      },
      {
        field: 'subscriptionsAdded',
        headerName: 'Nye brukerlisenser',
        minWidth: 160,
        flex: 1,
        align: 'left',
        headerAlign: 'left',
      },
    ];

    return (
      <DataGridPro
        autoHeight
        density="compact"
        rows={rows}
        columns={columns}
        localeText={nbNO.components.MuiDataGrid.defaultProps.localeText}
        pagination
        pageSizeOptions={[25, 50, 100]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 25,
              page: 0,
            },
          },
        }}
        sx={{
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 700,
          },
        }}
      />
    );
  }
}
